// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js??ref--6-1!../../../postcss-loader/lib/index.js??ref--6-2!./base.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("b7d72c48", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/style/base.css
// module id = nsZj
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 25 26 39 41 46 49 51 52 53 54 61 62 67 68 70 71 72 73 74 83 84 85 86 88 90 91 92 94 96 104 105